import * as React from 'react';
import { PageContentHero } from '../text-content/content.interface';

function Hero(props: { hero: PageContentHero, appLink: string }) {
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <div className="intro-text">
            <h1>
              <span className="name">IFELSE</span>
             <br />
              {props.hero.title}
            </h1>
            <p>{props.hero.desc}</p>
            <div className="btn_video_wrapper">
              <a href={props.appLink}  target="_blank" className="btn btn-default btn-default-style">
                Launch The App
              </a>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 img-wrapper intro-img-wrapper">
          <img src={props.hero.img} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Hero;